import React, { useState, useLayoutEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import {
  addResizeEndListener,
  removeResizeEndListener,
  getDimensions,
} from 'utils';

import { Container } from './styles';

const ContainerDimensions = ({ children }) => {
  const [state, setState] = useState({
    width: 0,
    height: 0,
    screenWidth: 0,
    screenHeight: 0,
  });
  const wrapper = useRef();

  useLayoutEffect(() => {
    onResize();
    const listener = addResizeEndListener(wrapper.current, onResize);
    return () => removeResizeEndListener(wrapper.current, listener);
  }, []);

  const onResize = () => {
    const { width, height } = getDimensions(wrapper.current);
    const {
      clientWidth: screenWidth,
      clientHeight: screenHeight,
    } = document.documentElement;

    setState({
      width,
      height,
      screenWidth,
      screenHeight,
    });
  };

  return <Container ref={wrapper}>{children(state)}</Container>;
};

ContainerDimensions.propTypes = {
  children: PropTypes.func.isRequired,
};

export default React.memo(ContainerDimensions);
